import React from "react";
import "./VirtualCards.css";
import VirtualCardScreen from "../../assests/virtual_cards.png";
import PhoneMockup from "../PhoneMockup/PhoneMockup";

const features = [
  {
    icon: "💳",
    title: "USD & CAD Virtual Cards",
    desc: "Instantly create virtual dollar and Canadian dollar cards — no paperwork, no waiting.",
  },
  {
    icon: "🌍",
    title: "Shop Globally",
    desc: "Pay on any website worldwide — Netflix, Amazon, Shopify stores, SaaS tools and more.",
  },
  {
    icon: "⚡",
    title: "Instant Issuance",
    desc: "Your card is ready in seconds. Fund it directly from your Sendcheap wallet.",
  },
  {
    icon: "🔒",
    title: "Freeze & Control",
    desc: "Freeze or delete a card at any time. Full spending limits and transaction controls.",
  },
];

const VirtualCards = () => {
  return (
    <section className="vcards-section">
      <div className="vcards-inner">

        {/* Left — phone mockup */}
        <div className="vcards-left">
          <div className="vcards-pm-wrap">
            {/* Glow blob */}
            <div className="vcards-glow"></div>

            <PhoneMockup
              screenshot={VirtualCardScreen}
              alt="Virtual card screen"
              size="lg"
              className="vcards-pm"
            />

            {/* Floating card — USD */}
            <div className="vcards-float vcards-float-usd">
              <div className="vf-card-visual usd">
                <span className="vf-card-chip">▣</span>
                <span className="vf-card-currency">USD</span>
              </div>
              <div>
                <div className="vf-label">Dollar Card</div>
                <div className="vf-num">•••• •••• •••• 4291</div>
              </div>
            </div>

            {/* Floating card — CAD */}
            <div className="vcards-float vcards-float-cad">
              <div className="vf-card-visual cad">
                <span className="vf-card-chip">▣</span>
                <span className="vf-card-currency">CAD</span>
              </div>
              <div>
                <div className="vf-label">Canadian Card</div>
                <div className="vf-num">•••• •••• •••• 8163</div>
              </div>
            </div>

            {/* Floating badge — instant */}
            <div className="vcards-float vcards-float-badge">
              <span className="vf-badge-dot"></span>
              Card ready in &lt;10s
            </div>
          </div>
        </div>

        {/* Right — text */}
        <div className="vcards-right">
          <span className="vcards-label">Virtual Cards</span>
          <h2 className="vcards-title">
            Spend globally with your<br />
            <span className="vcards-accent">virtual dollar card.</span>
          </h2>
          <p className="vcards-desc">
            Create USD and CAD virtual cards instantly. Shop on any international platform,
            subscribe to services, and manage your spending — all from the Sendcheap app.
          </p>

          <div className="vcards-features">
            {features.map((f, i) => (
              <div className="vcards-feat" key={i}>
                <div className="vcards-feat-icon">{f.icon}</div>
                <div>
                  <div className="vcards-feat-title">{f.title}</div>
                  <div className="vcards-feat-desc">{f.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <a href="https://onelink.to/n9hyxn" target="_blank" rel="noreferrer">
            <button className="vcards-btn">Get Your Card &rarr;</button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default VirtualCards;
